import React from 'react';

import CustomHours1 from './CustomHours1';

const CustomHours = ({ placeId, serviceTypeSettingId }) => (
  <CustomHours1 placeId={placeId} serviceTypeSettingId={serviceTypeSettingId} />
);
export default CustomHours;
